import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from './user';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class UserService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }
 
  Get(): Observable<User[]> {
    return this.httpClient.get<User[]>(this.baseUrl + 'api/UserApi')
  }
  GetActive(): Observable<User[]> {
    return this.httpClient.get<User[]>(this.baseUrl + 'api/UserApi/GetActiveUsers')
  }
  GetEditableUser(): Observable<User[]> {
    return this.httpClient.get<User[]>(this.baseUrl + 'api/UserApi/GetEditableUser')
  }
  Delete(user: User) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/UserApi/delete', user, { headers: header, observe: 'response' });
  }
 
}

